import { render, staticRenderFns } from "./TaxConfigModal.vue?vue&type=template&id=c81b3c2c"
import script from "./TaxConfigModal.vue?vue&type=script&lang=js"
export * from "./TaxConfigModal.vue?vue&type=script&lang=js"
import style0 from "./TaxConfigModal.vue?vue&type=style&index=0&id=c81b3c2c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports